import { useSearchParam } from 'lib/useSearchParam';
import { usePathname } from 'next/navigation';

const bannedRoutes = ['sign-up', 'product', 'developer'] as const;

export const useHideMobileLogInOrRegister = () => {
  const pathname = usePathname() ?? '';
  const isBanned = bannedRoutes.some(route => pathname.includes(route));
  const isHideMobileLoginParam = useSearchParam('hideMobileLogin') === 'true';

  return isBanned || isHideMobileLoginParam;
};
